/**
 * Validação e normalização de CNPJ (numérico e alfanumérico).
 * Alinhado com C4U.Web.Components — IN RFB nº 2.229/2024.
 */
export class CnpjHelper {
  static readonly LENGTH = 14;

  private static readonly WEIGHTS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  private static readonly WEIGHTS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  private static readonly BODY_PATTERN = /^[0-9A-Z]{12}\d{2}$/;

  static normalize(value?: string | null): string {
    if (!value) return "";
    return value.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
  }

  static toNull(value: unknown): string | null {
    if (value === null || value === undefined || value === "") return null;
    const normalized = CnpjHelper.normalize(String(value));
    return normalized || null;
  }

  private static charValue(char: string): number {
    return char.charCodeAt(0) - 48;
  }

  private static isOnlySameChar(value: string): boolean {
    return /^(.)\1+$/.test(value);
  }

  private static calculateDv(base: string, weights: number[]): number {
    let sum = 0;
    for (let i = 0; i < weights.length; i++) {
      sum += CnpjHelper.charValue(base[i]) * weights[i];
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  }

  static isValid(value?: string | null): boolean {
    const normalized = CnpjHelper.normalize(value);

    if (!normalized) return true;

    if (
      normalized.length !== CnpjHelper.LENGTH ||
      !CnpjHelper.BODY_PATTERN.test(normalized) ||
      CnpjHelper.isOnlySameChar(normalized)
    ) {
      return false;
    }

    const dv1 = CnpjHelper.calculateDv(
      normalized.slice(0, 12),
      CnpjHelper.WEIGHTS_DV1
    );
    if (dv1 !== Number(normalized[12])) return false;

    const dv2 = CnpjHelper.calculateDv(
      normalized.slice(0, 12) + dv1,
      CnpjHelper.WEIGHTS_DV2
    );
    return dv2 === Number(normalized[13]);
  }
}
